<template>
  <div class="mock-header2024">
    <div class="top clearfix">
      <div class="logo">
        <a href="//www.chinaacc.com" target="_blank"></a>
      </div>
      <div class="title">机考模拟系统</div>
    </div>
    <div class="mini-header">
      <div class="con clearfix">
        <h2>{{ category }}</h2>
        <h3>{{ courseName }}</h3>
        <div class="check_box">
          <el-dropdown trigger="click" placement="bottom"  @command="toggleCourse">
            <p>切换</p>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,idx) in courseList"
                                :key="idx"
                                :command="item.siteCourseID"
                                v-html="item.siteCourseName">
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { category } from '@base/settings'
  import {parseNumber, setPageTitle, setCookie} from "@/utils"

  export default {
    name: 'MockHeader',

    data() {
      return {
        category: category,
        //Query参数
        courseID: "",
        siteCourseID: "",
        majorID: "",
        flag: "",
        //列表
        courseList: [],
        //其他变量
        courseName: ""
      }
    },
    async mounted() {
      this.initData()
      await this.getCourseInfo()
    },
    methods: {
      initData() {
        const {majorID} = this.$categoryInfo
        const {flag} = this.$route.params
        const {siteCourseID, courseID} = this.$route.query
        this.flag = flag === 'paidExam' ? '' : flag
        this.majorID = majorID
        this.courseID = parseNumber(courseID)
        this.siteCourseID = parseNumber(siteCourseID)
      },
      async getCourseInfo() {
        let params = {
          flag: this.flag,
          majorID: this.majorID,
          siteCourseID: this.siteCourseID
        }
        await this.$store.dispatch("getCurrentSiteInfo", params).then(res => {
          const {allSiteList, currentCourse} = res
          this.courseList = allSiteList
          const {siteCourseName} = currentCourse
          document.title = setPageTitle(siteCourseName)
          this.courseName = siteCourseName
          setCookie('courseName', this.courseName)
        }).catch(err => {
          this.$message.error(err.msg)
        })
      },
      toggleCourse(command) {
        this.courseList.forEach(item => {
          if (item.siteCourseID === command) {
            document.title = setPageTitle(item.siteCourseName)
            this.courseName = item.siteCourseName
            const {flag} = this.$route.params
            this.$router.push({
              path: `/${flag}/mockExam`,
              query: {
                siteCourseID: command,
                courseID: item.courseID
              }
            })
            this.$route.query.courseID = item.courseID
            this.$route.query.siteCourseID = command
            this.$parent.initData()
            this.$parent.getExamThemeList()
          }
        })
      }
    }
  }
</script>
<style lang="scss">

  .mock-header2024 {
    background-color: #fff;
    margin: 0 auto;

    .top {
      position: relative;
      height: 70px;
      width: 1200px;
      margin: 0 auto;

      .logo {
        float: left;
        height: 62px;
        display: inline-block;

        a {
          background: url("//www.chinaacc.com/images/logo.png") no-repeat;
          width: 157px;
          height: 42px;
          margin: 14px 0 0;
          display: block;
        }
      }

      .title {
        float:left;
        text-align: left;
        margin-left:47px;
        width: 400px;
        font-size: 28px;
        font-weight: bold;
        line-height: 70px;
        color: #222;
      }
    }

    .check_box {
      float:left;
      position: relative;
      margin:25px 0 0 19px;
      p {
        background:#fff;
        border-radius:40px;
        padding: 0 34px 0 14px;
        line-height: 28px;
        display: flex;
        align-items: center;
        font-style: normal;
        color:#07BDC7;
        cursor: pointer;
      }
      &:before{
        content:"";
        width:15px;
        height:12px;
        background: url("~@/assets/images/mockExam/mockExam-ico01.png") no-repeat;
        position:absolute;
        right:12px;
        top:8px;
        z-index:9;
      }
    }

    .mini-header {
      background: url("~@/assets/images/mockExam/header2024.jpg") no-repeat top center;
      height: 80px;
      color: #fff;
      width: 100%;
      margin: 0 auto;

      .con {
        height: 80px;
        width: 1200px;
        margin: 0 auto;

        h2 {
          margin: 0 39px 0 0;
          font-size: 26px;
          line-height: 80px;
          font-weight:bold;
          float: left;
          display: inline-block;
        }

        h3 {
          margin: 0;
          font-size: 18px;
          line-height: 80px;
          font-weight:normal;
          float: left;
          display: inline-block;
        }
      }
    }
  }

</style>
